import FileSaver from "file-saver";
import { apiGetLocationFile } from "src/api/location.api";
import { type LocationModel } from "src/types/location";

import { type DataItem, type FileItem, type FolderItem } from "../interfaces/DataItem";

export async function downloadHandler(fileId: string, fileName: string): Promise<void> {
  try {
    const fileContent = await apiGetLocationFile(fileId, true);
    const blob = new Blob([fileContent]);
    FileSaver.saveAs(blob, fileName);
  } catch {
    throw new Error("Failed to download file");
  }
}

export function getFolderItemsFromLocations(locations: LocationModel[], locationId: string): FolderItem[] {
  return locations
    .filter((location) => location.ParentId === locationId)
    .sort((a, b) => a.LocalName.localeCompare(b.LocalName))
    .map((location) => ({ id: location.Id, name: location.LocalName, type: "folder", location }));
}

export function getFileItemsFromLocationFiles(files: LocationFileDto[]): FileItem[] {
  return files
    .sort((a, b) => a.fileName.localeCompare(b.fileName))
    .map((file) => ({ id: file.id, name: file.fileName, type: "file", file }));
}

export function getDataItemsForLocationId(
  locations: LocationModel[],
  locationId: string | undefined,
  files: LocationFileDto[]
): DataItem[] {
  return locationId ? [...getFolderItemsFromLocations(locations, locationId), ...getFileItemsFromLocationFiles(files)] : [];
}
